const TicketByObjet = (props) => {
  const { data } = props;

  return (
    <>
      <h2>Nombre de tickets par objet</h2>
      <div className="list contentDashboard">
        {Object.keys(data)?.map((key, index) => {
          return (
            <div key={index} className="item">
              <div>{key}</div>
              <div>
                <span className="nbTicket">{data[key]?.data?.length}</span>{" "}
                ticket{data[key]?.data?.length>0?'s' : ''}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
export default TicketByObjet;
